import type { ReactElement } from 'react';
import React from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

export interface IProps {
  large?: boolean;
  className?: string;
  children: React.ReactNode;
}

const Styled = styled.div`
  max-width: ${({ large }: IProps) => (large ? '1920px' : '1440px')};
  width: 100%;
  padding: 0;
  margin: 0 auto;
`;

function Container({ large = false, className = '', ...props }: IProps): ReactElement {
  return (
    <Styled large={large} className={classNames('container', large ? '-large' : '', className)} {...props} />
  );
}

Container.displayName = 'Container';
export default Container;
